/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Who_OverlineInputs */

const en_cp_who_overline = /** @type {(inputs: Cp_Who_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WHO IT IS FOR`)
};

const id_cp_who_overline = /** @type {(inputs: Cp_Who_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UNTUK SIAPA`)
};

/**
* | output |
* | --- |
* | "WHO IT IS FOR" |
*
* @param {Cp_Who_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_who_overline = /** @type {((inputs?: Cp_Who_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Who_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_who_overline(inputs)
	return en_cp_who_overline(inputs)
});